export default function HomeHeader () {
    return (
        <div className='section top'>
            <div className='header'/>
            <div className="image"/>
        </div>
    );
}
